module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gameover_game"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "gameover"
  }, [_c('div', {
    staticClass: "gameover-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "gameover-button"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/gamelist',
        query: {
          id: 1
        }
      }
    }
  }, [_vm._v("返回首页测试")]), _vm._v(" "), _c('a', {
    staticClass: "gameover-button-on",
    on: {
      "click": _vm.carryGame
    }
  }, [_vm._v("继续测试")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372f5bb0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gameover.vue
// module id = 752
// module chunks = 1